import { ShipmentFlag } from "@redotech/redo-fulfillment-operations-common/shipment-flag";
import AlertTriangleIcon from "@redotech/redo-icons/alert-triangle.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";

export const ShipmentFlagsBadge = memo(function ShipmentFlagsBadge({
  flags,
}: {
  flags: readonly ShipmentFlag[];
}) {
  if (!flags.length) {
    return null;
  }

  const warningText =
    flags.length === 1 ? "1 warning" : `${flags.length} warnings`;

  return (
    <Tooltip
      leftAlign
      title={
        <Flex dir="column" gap="sm">
          {flags.map((flag) => (
            <Text fontSize="xs" key={flag.message}>
              • {flag.message}
            </Text>
          ))}
        </Flex>
      }
    >
      <div>
        <RedoBadge
          color="warning"
          segmentLeading={{ type: "icon", Icon: AlertTriangleIcon }}
          size="md"
          text={
            <Flex flexDirection="column" pb="xxs">
              <Text as="span" fontSize="xs" textDecoration="underline">
                {warningText}
              </Text>
            </Flex>
          }
        />
      </div>
    </Tooltip>
  );
});
